import React from 'react';

import Button from '../../Controls/Button';
import Menu from './Menu';

import modalActions from '../../../store/actions/modals';
import { useAppDispatch } from '../../../store/hooks';
import { CONTACT_US_MODAL } from '../../../constants/modals';
import { $l } from '../../../locales';

const Sidebar = () => {
  const dispatch = useAppDispatch();

  const submitTicket = () => {
    dispatch(modalActions.openModal({ name: CONTACT_US_MODAL }));
  };

  return (
    <>
      <Button
        onClick={submitTicket}
        radius="20"
        icon="20--message"
        text={$l('CONTACT_US.BUTTON')}
        className="indent-md-bottom"
      />
      <Menu />
    </>
  );
};

export default Sidebar;
